import { render, staticRenderFns } from "./urkunde_a4.vue?vue&type=template&id=25c6e6d3&scoped=true"
import script from "./urkunde_a4.vue?vue&type=script&lang=js"
export * from "./urkunde_a4.vue?vue&type=script&lang=js"
import style0 from "./urkunde_a4.vue?vue&type=style&index=0&id=25c6e6d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c6e6d3",
  null
  
)

export default component.exports